// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__28RnR","title":"ClientInsurance_title__3L4_G","itemText":"ClientInsurance_itemText__308VD"};